import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NguCarousel, NguCarouselStore, NguCarouselConfig } from '@ngu/carousel';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {

  carouselConfig: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
    slide: 1,
    speed: 700,
    load: 3,
    interval: {timing: 10000, initialDelay: 1000},
    loop: true,
    touch: true,
    velocity: 0.2
  }
  carouselItems = ['locationPage.activity1', 'locationPage.activity2', 'locationPage.activity3', 'locationPage.activity4'];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(){

  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

}